<template>
  <CCardBody class="p-0 animate__animated animate__fadeInLeft animate__faster">
    <div class="app__title bg-dark--custom pt-4">
      <h2 class="m-0 text-center" style="color: white">Asegura tu auto</h2>
      <div class="container">
        <p
          class="
            app__subtitle
            text-center
            mt-3
            pt-1
            animate__animated animate__backInUp
          "
          v-if="step === 0"
        >
          Selecciona un auto para proteger
        </p>
        <p
          class="
            app__subtitle
            text-center
            mt-3
            pt-1
            animate__animated animate__backInUp
          "
          v-if="step === 1"
        >
          Selecciona el periodo de protección
        </p>
        <p
          class="
            app__subtitle
            text-center
            mt-3
            pt-1
            animate__animated animate__backInUp
          "
          v-if="step === 2"
        >
          Resúmen de compra
        </p>
        <p
          class="
            app__subtitle
            text-center
            mt-3
            pt-1
            animate__animated animate__backInUp
          "
          v-if="step === 3"
        >
          Confirmación de la compra
        </p>
      </div>
    </div>
    <main class="app__main d-flex flex-column justify-content-center">
      <!-- Rediseño home: Pantalla 1 -->
      <div
        class="
          app__step
          card-body--custom
          d-flex
          flex-wrap
          justify-content-around
          align-items-baseline
          card__auto__container
          animate__animated animate__fadeIn
        "
        v-if="step === 0"
      >
        <div
          class="alert alert-danger text-center m-0 col-12"
          v-if="autos.length === 0"
        >
          Aún no tienes autos dados de alta
        </div>
        <div class="card" v-for="(auto, i) of autos" v-bind:key="i">
          <div class="relative mb-3">
            <div class="card__img__container">
              <img :src="auto.FotoVehiculo" class="card-img-top" alt="" />
            </div>
            <div
              class="card__badge__status status--success"
              v-if="auto.DiasVigenciaActivacion > 0"
            >
              <i class="fas fa-shield-alt"></i> Protegido
            </div>
            <div class="card__badge__status status--danger" v-else>
              <i class="fas fa-exclamation-triangle"></i> Sin protección
            </div>
          </div>
          <div class="card-body text-center pb-2 pl-1 pr-1">
            <div class="badge badge-secondary">
              Póliza: {{ auto.NumeroPoliza }}
            </div>
            <h5 class="card-title mt-3 mb-4">
              {{ auto.DescripcionVehiculo }}
            </h5>
            <button
              class="btn col-12 btn-primary--custom"
              @click="handleStep1(auto)"
            >
              Proteger
            </button>
          </div>
        </div>
      </div>

      <!-- Rediseño home: Pantalla 2 -->
      <div
        class="app__step app__step-1 animate__animated animate__fadeIn"
        v-if="step == 1"
        style="padding-bottom: 320px !important"
      >
        <div class="no-abs d-flex justify-content-start p-1 card--dates">
          <a @click="setStep(0)" class="btn-prev mr-1"
            ><i class="fas fa-arrow-left"></i
          ></a>
        </div>

        <div class="">
          <div
            class="form-group card-body--custom border--origin card--dates"
            style="overflow: visible"
          >
            <h4 class="text-center">
              <span class="text-secondary"
                ><i class="fas fa-calendar-alt"></i
              ></span>
              Desde el día
            </h4>

            <div class="input-group input-group-lg">
              <datepicker
                :fullscreenMobile="true"
                :disabledDates="disabledDates"
                placeholder="Selecciona la fecha de inicio"
                :value="today"
                @selected="handleDateStart"
                name="startDate"
                input-class="form-control myCalendar text-center"
              ></datepicker>
              <small
                v-if="errorDate1"
                class="text-danger text-center col-12 p-0"
                >La fecha no puede ser menor a la de hoy</small
              >
            </div>
          </div>
          <div
            class="form-group mt-4 card-body--custom border--origin card--dates"
          >
            <h4 class="text-center">
              <span class="text-secondary"
                ><i class="fas fa-clock fs-25"></i
              ></span>
              A las
            </h4>

            <div class="input-group input-group-lg">
              <select
                name="hour"
                class="form-control col-6 text-center"
                id="time"
                @change="handleStep2"
              >
                <option value="0">00</option>
                <option :value="i" v-for="i in 23" v-bind:key="i">
                  {{ i }}
                </option>
              </select>
              <span class="p-2"> : </span>
              <select
                name="minutos"
                class="form-control col-6 text-center"
                @change="handleStep2"
              >
                <option value="00">00</option>
                <option value="30">30</option>
              </select>
              <div
                class="col-12 error__message text-danger text-center"
                v-if="hourError"
              >
                La hora no puede ser menor a la actual
              </div>
            </div>
          </div>
          <div
            class="form-group mt-4 card-body--custom border--end card--dates"
            style="overflow: visible"
          >
            <h4 class="text-center">
              <span class="text-secondary"
                ><i class="fas fa-calendar-alt fs-25"></i
              ></span>
              Hasta el día
            </h4>
            <div class="input-group input-group-lg">
              <datepicker
                placeholder="Selecciona fecha de fin"
                :disabledDates="disabledDates2"
                @selected="handleDateEnd"
                name="endDate"
                input-class="form-control myCalendar text-center"
              ></datepicker>
              <small
                v-if="errorDate2"
                class="text-danger text-center col-12 p-0"
                >La fecha debe ser mayor a la de inicio</small
              >
            </div>
          </div>

          <div class="form-group mt-4" v-if="step == 1">
            <small class="text-center d-block">Costo por día</small>
            <h1 class="app__price text-center">${{ mDiaShow }}</h1>
          </div>
        </div>
      </div>

      <!-- Rediseño home: Pantalla 3 -->
      <div v-if="step === 2" class="animate__animated animate__fadeIn">
        <div class="no-abs d-flex justify-content-start p-1">
          <a @click="setStep(1)" class="btn-prev mr-1"
            ><i class="fas fa-arrow-left"></i
          ></a>
        </div>

        <div class="card-body--custom">
          <table class="table table--resumen">
            <thead>
              <tr>
                <th colspan="3" class="bg-gradient-primary--custom text-center">
                  {{ resumenCompra.auto.DescripcionVehiculo }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center">
                <td>Costo por día</td>
                <td>Total de días</td>
                <th>Total a pagar</th>
              </tr>
              <tr class="text-center">
                <td>${{ resumenCompra.PrimaTotal }}</td>
                <td>{{ resumenCompra.dias }}</td>
                <th>${{ resumenCompra.total }}</th>
              </tr>
            </tbody>
          </table>

          <div class="btn-groups d-flex justify-content-end">
            <div class="btn btn-primary--custom" @click="handlePayment">
              Confirmar
            </div>
          </div>
        </div>
      </div>

      <div class="animate__animated animate__fadeIn" v-if="step == 3">
        <div class="no-abs d-flex justify-content-start p-1">
          <a @click="setStep(2)" class="btn-prev mr-1"
            ><i class="fas fa-arrow-left"></i
          ></a>
          <a @click="handleHome" class="btn-prev text-light btn-prev--alt"
            ><i class="fas fa-home"></i
          ></a>
        </div>

        <div
          class="
            m-auto
            d-flex
            flex-column
            p-0
            card-body--custom
            app__step-3
            scroll
          "
          id="payment__container"
        >
          <Payment :data="fillUserData" @onExit="handlePaymentDestroy" />
        </div>
      </div>
    </main>
  </CCardBody>
</template>


<script>
import { Carousel3d, Slide } from "vue-carousel-3d";
import { format } from "../../assets/helpers";
import Payment from "../../componentes/Payment";

import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import * as lang from "vuejs-datepicker/src/locale";
import { getBaseUrl } from "../../store/actions/ModuloActions";
import axios from "axios";

export default {
  components: {
    Carousel3d,
    Slide,
    Payment,
    Datepicker,
  },
  data: function () {
    return {
      lang: lang.es,
      dates: { from: null, to: null, time: null },

      resumenCompra: { auto: {}, tiempo: {} },
      today: new Date(),
      minDate: null,
      disabledDates: {
        from: null,
        to: null,
      },
      disabledDates2: {},
      mDiaShow: 0,

      loadingPrice: false,
      spinnerMessage: false,
      hourError: false,

      errorDate1: false,
      errorDate2: false,
      step: 0,
    };
  },

  props: {
    autos: Array,
    userData: Object,
  },
  methods: {
    // Pantalla 1: selecciona un coche
    async handleStep1({
      NumeroPoliza,
      DescripcionVehiculo,
      VigenciaFinalActivacion,
      VigenciaFinalPoliza,
    }) {
      let vigenciaPoliza = new Date(
        format.date(VigenciaFinalPoliza, "aaaa/mm/dd")
      );
      vigenciaPoliza = new Date(
        vigenciaPoliza.setDate(vigenciaPoliza.getDate() + 1)
      );

      this.minDate = format.date(VigenciaFinalActivacion, "aaaa/mm/dd");
      // this.today = format.date(VigenciaFinalActivacion, "aaaa/mm/dd");
      const d = new Date();
      d.setDate(d.getDate() - 1);
      this.disabledDates.to = new Date(format.date(VigenciaFinalActivacion, "aaaa/mm/dd"));
      console.log(this.disabledDates.to);
      this.disabledDates.from = new Date(
        format.date(vigenciaPoliza, "aaaa/mm/dd")
      );
      this.disabledDates2.to = new Date();
      this.disabledDates2.from = new Date(
        format.date(vigenciaPoliza, "aaaa/mm/dd")
      );
      this.$store.state.spinnerMessage = false;
      this.$store.state.showSpinner = true;
      this.resumenCompra.auto = {
        NumeroPoliza,
        DescripcionVehiculo,
      };
      const costoPoliza = await this.getAutoPrice(NumeroPoliza);

      if (costoPoliza) {
        this.$store.state.showSpinner = false;
        this.$store.state.spinnerMessage = false;
        this.resumenCompra.PrimaTotal = costoPoliza.PrimaTotal;
        this.mDiaShow = format.money(costoPoliza.PrimaTotal);
        this.resumenCompra.Referencia = costoPoliza.ReferenciaPago;
      }
      this.step = 1;
    },

    // Pantalla 2: Selecciona periodo de tiempo
    handleStep2() {
      const date1 = document.querySelector("[name='startDate']");
      const date2 = document.querySelector("[name='endDate']");
      const hour = document.querySelector("#time");
      const now = new Date();
      now.setHours(0, 0, 0, 0);

      // Valida fechas
      if (date1.value != "") {
        const beginDate = new Date(date1.value);
        beginDate.setHours(24, 0, 0, 0);

        if (now > beginDate) {
          this.errorDate1 = true;
          return;
        } else this.errorDate1 = false;
      }

      if (date2.value != "") {
        const endDate = new Date(date2.value);
        endDate.setHours(24, 0, 0, 0);

        if (date1.value != "") {
          const beginDate = new Date(date1.value);
          beginDate.setHours(24, 0, 0, 0);

          if (endDate <= beginDate) {
            this.errorDate2 = true;
            return;
          } else this.errorDate2 = false;
        } else {
          if (endDate < now) {
            this.errorDate2 = true;
            return;
          } else this.errorDate2 = false;
        }
      }

      if (date1.value != "" && date2.value != "" && hour.value != "") {
        if (
          hour.value < new Date().getHours() &&
          new Date(date2.value).getDate() <= new Date().getDate() &&
          new Date(date2.value).getMonth() <= new Date().getMonth() &&
          new Date(date2.value).getFullYear() <= new Date().getFullYear()
        ) {
          this.hourError = true;
          return;
        } else {
          this.hourError = false;
        }

        this.step = 2;
        const from = new Date(
          document.querySelector("[name='startDate']").value
        );
        const to = new Date(document.querySelector("[name='endDate']").value);

        this.resumenCompra.tiempo.from = format.date(from);
        this.resumenCompra.tiempo.to = format.date(to);
        this.resumenCompra.tiempo.hour = hour.value;
        this.resumenCompra.tiempo.min = document.querySelector(
          "select[name='minutos']"
        ).selectedOptions[0].value;

        this.resumenCompra.dias = this.handleDate(date1.value, date2.value);
        this.resumenCompra.total = format.money(
          this.resumenCompra.dias * this.resumenCompra.PrimaTotal
        );
      }
    },
    async handleDateStart(date) {
      const d = new Date(date);
      const month =
        d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
      const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
      this.dates.from = `${d.getFullYear()}/${month}/${day}`;
      this.resumenCompra.dates.from = `${d.getFullYear()}/${month}/${day}`;
      const date1 = await document.querySelector("[name='startDate']");

      if (date1.value) {
        this.handleStep2();
      }
    },
    async handleDateEnd(date) {
      const d = new Date(date);
      const month =
        d.getMonth() + 1 < 10 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
      const day = d.getDate() < 10 ? `0${d.getDate()}` : d.getDate();
      this.dates.to = `${d.getFullYear()}/${month}/${day}`;
      this.resumenCompra.tiempo.to = `${d.getFullYear()}/${month}/${day}`;
      const date2 = await document.querySelector("[name='endDate']");
      if (date2.value) {
        this.handleStep2();
      }
    },

    // Pantalla 3: Confirmación de compra
    handlePayment() {
      localStorage.setItem("ref", JSON.stringify(this.resumenCompra));
      this.fillUserData.Monto = this.resumenCompra.total;
      this.fillUserData.Referencia = this.resumenCompra.Referencia;
      this.fillUserData.NumeroPoliza = this.resumenCompra.auto.NumeroPoliza;
      this.step = 3;
    },

    // Auxiliares
    handleDate(dateStart, dateEnd) {
      const fecha1 = new Date(dateStart);
      const fecha2 = new Date(dateEnd);
      const resta = fecha2.getTime() - fecha1.getTime();
      return resta / (1000 * 3600 * 24);
    },
    setStep(step) {
      this.step = step;
    },
    handleHome() {
      this.step = 0;
    },

    // API's
    async handlePaymentDestroy() {
      this.$store.state.showSpinner = true;
      this.$store.state.spinnerMessage = "Revisando status de tu transacción";

      const data = localStorage.getItem("ref");
      const status = await this.isActivationPending(JSON.parse(data));

      if (status) {
        this.$store.state.spinnerMessage = "Activando tu póliza...";

        const isActivated = await this.activarPoliza(JSON.parse(data));
        if (isActivated) {
          this.$store.state.spinnerIcon = "success";
          this.$store.state.spinnerMessage = `Tu póliza ${isActivated} ha sido activada correctamente`;
          return;
        } else
          this.$store.state.spinnerMessage =
            "Lo sentimos, ha ocurrido un problema";
        setTimeout(() => {
          this.$store.state.showSpinner = false;
          this.$store.state.spinnerMessage = false;
        }, 1500);
      } else {
        this.$store.state.spinnerMessage =
          "La activación de tu póliza no fue efectuada.";
        setTimeout(() => {
          this.$store.state.showSpinner = false;
          this.$store.state.spinnerMessage = false;
        }, 1500);
      }
    },
    async getAutoPrice(poliza) {
      const url = `${getBaseUrl()}danos/api/v1/autodiario/getcosto/${poliza}`;
      const prom = await axios.get(url, {
        headers: {
          XAPPID: "F827FE82207B214D85FB0C8856B1BCB411D4",
          Authorization: `Bearer ${this.$route.query.token}`,
        },
      });
      return prom.data.data;
    },
    async activarPoliza(data) {
      const payload = {
        metodo: "ACTIVARPOLIZAAD",
        data: {
          Idusuario: this.$route.query.id,
          NumeroPoliza: data.auto.NumeroPoliza,
          ReferenciaPago: data.Referencia,
          VigenciaInicial: data.tiempo.from,
          VigenciaFinal: data.tiempo.to,
          HoraInicial: `${data.tiempo.hour}:${data.tiempo.min}`,
        },
      };

      const response = await this.$store.dispatch("metodoPost", payload);
      if (response) {
        localStorage.removeItem("ref");
        return data.Referencia;
      } else return false;
    },

    async isActivationPending(data) {
      const headers = {
          XAPPID: "F827FE82207B214D85FB0C8856B1BCB411D4",
          Authorization: `Bearer ${this.$route.query.token}`,
        };
      const url = `${getBaseUrl()}cobranza/api/v1/ConsultarRespuestaPagoBanco`;
      const data_post = {
          IdBanco: "31",
          IdApp: "6",
          Referencia: data.Referencia,
          Monto: 0.0,
          PromocionMeses: "000000",
          NumeroPoliza: "000000",
          TipoMoneda: "MXN",
          PromoPlan: "03",
        };
      const response = await axios.post(
        url,
        //{ Referencia: data.Referencia },
        data_post,
        { headers }
      );

      if (response.status == 200) {
        if (response.data.flag) {
          if (response.data.data[0].status.toUpperCase() == "A") {
            return true;
          }
        } else {
          const exception = response.data.errorMessage.toUpperCase();
          if (exception == "RECHAZADO" || exception == "FALLADO") {
            localStorage.removeItem("ref");
          }
          return false;
        }
      } else return false;
    },
  },
  async mounted() {
    const polizaPendiente = localStorage.getItem("ref");
    if (polizaPendiente) {
      this.handlePaymentDestroy();
    }
  },

  computed: {
    fillUserData() {
      const { nombre, amaterno, apaterno, usuario } =
        this.$store.state.userData;

      return {
        IdBanco: "31",
        // IdApp: this.userData.idaplicacion,
        IdApp: "6",
        Referencia: "",
        Monto: "0",
        PromocionMeses: "000000",
        NumeroPoliza: "",
        TipoMoneda: "MXN",
        Pais: "MX",
        Correo: usuario,
        Nombre: nombre,
        Apellidos: `${amaterno} ${apaterno}`,
        Domicilio: this.$store.state.autos[0],
      };
    },
  },
};
</script>


<style lang="scss">
#payment__container {
  // height: 500px;
  height: calc(100vh - 64px);
}
@media only screen and (min-width: 700px) {
  #payment__container {
    height: 800px;
  }
}
.vdp-datepicker {
  width: 100%;
}
.myCalendar {
  height: 43px;
  width: 100% !important;
  background-color: white !important;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.selected {
  border-radius: 10px !important;
  background-color: #024079 !important;
  color: white;
}
.cell:hover {
  border-radius: 10px !important;
  border: 1px solid #024079 !important;
}
.vdp-datepicker__calendar {
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.637);
  color: #024079;
}
</style>